import React, { useState, useEffect } from 'react';
import './DashboardOperativo.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { faUserDoctor, faCalendarCheck, faStethoscope, faFilter, faClock, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { useAuthServices } from '../../services/useFetch';
import { Citas } from '../Agenda/Citas/Citas';

const DashboardOperativo = () => {

    const { requestPost } = useAuthServices();

    const [executeConsulta, setExecuteConsulta] = useState(true)
    const [modalError, setModalError] = useState(false)
    const [citasList, setCitasList] = useState([])

    const [totalProfesionales, setTotalProfesionales] = useState(0);
    const [profesionalesActivos, setProfesionalesActivos] = useState(0);
    const [citasTotalesHoy, setCitasTotalesHoy] = useState(0);

    useEffect(() => {
        obtieneListadoCitasService()
    }, []);

    const obtieneListadoCitasService = async () => {
        let usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage)
            console.log(usuarioLocalStorageObj)
            const body = {
                idUsuario: usuarioLocalStorageObj.idCompany,
                orden: "DESC"
            }
            const response = await requestPost(body, 22);
            if (!response.error) {
                const { estado, objeto } = response.data
                if (estado) {
                    setCitasList(objeto)
                }
            } else {
                setModalError(true)
            }
        }
    }

    const handleCloseError = () => {
        setModalError(false)
    }

    return (
        <>
            <div className="medical-dashboard-container">
                <div className="dashboard-header">
                    <h1 className='size-db-info-agenda-h1'>
                        Panel de Control Operativo
                    </h1>
                    <p className="p-label-form">Gestión centralizada de profesionales y agenda en tiempo real.</p>
                </div>
                <div className="row kpi-row">
                    <div className="col-12 col-md-4">
                        <div className="kpi-card">
                            <div className="kpi-icon-wrapper kpi-icon-primary">
                                <FontAwesomeIcon icon={faUserDoctor} />
                            </div>
                            <div className="kpi-info">
                                <h3>{totalProfesionales}</h3>
                                <p>Profesionales Totales</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="kpi-card">
                            <div className="kpi-icon-wrapper kpi-icon-success">
                                <FontAwesomeIcon icon={faStethoscope} />
                            </div>
                            <div className="kpi-info">
                                <h3>{profesionalesActivos}</h3>
                                <p>Activos Ahora</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="kpi-card">
                            <div className="kpi-icon-wrapper kpi-icon-warning">
                                <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <div className="kpi-info">
                                <h3>{citasTotalesHoy}</h3>
                                <p>Citas Programadas Hoy</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='div-container-db-agenda mt-0'>
                <Citas citasList={citasList} executeConsulta={executeConsulta} setExecuteConsulta={setExecuteConsulta} origen="AGENDA_ADMIN" />
            </div>
            <Modal isOpen={modalError} onHide={handleCloseError} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>Error de comunicación <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p>Vaya, tenemos algunas dificultades de comunicación en este momento, por favor intenta mas tarde.</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseError}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default DashboardOperativo;
